export default __webpack_public_path__ + "static/media/mauricio-party.cf36cd17.jpeg";